import { Component, Input, OnDestroy } from '@angular/core';
import { Observable } from 'rxjs';
import { Matter } from '../../core/models/matter';
import { MatterService } from '../../core/services/matter.service';

@Component({
  selector: 'app-matter',
  templateUrl: './view-matter.component.html',
  styleUrl: './view-matter.component.scss'
})
export class ViewMatterComponent {

  matter$!: Observable<Matter>;
  matter!: Matter;

  constructor(private matterService: MatterService) {}

  _id : string = "";

    @Input()
    set id(id: string){
      this._id = id;
      this.matter$ = this.matterService.getMatter(id);
      this.matter$.subscribe((matter) => {
        this.matter = matter;
      });
    }
    get id(): string {
      return this._id;
    }

}
